import dayjs from 'dayjs';

export const formatDate = (date, formatType = 'DD-MM-YYYY') => {
    if (!date) return '';
    return dayjs(date).format(formatType);
};



export const formatDateTime = (input, formatType = 'hh:mm A') => {
    if (!input) return '';
    return dayjs(input).format(formatType);
};

export const formatDateTimeFull = (input, formatType = 'DD-MM-YYYY hh:mm A') => {
    if (!input) return '';
    return dayjs(input).format(formatType);
};